import { Box, TextField, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export type WizardFileFieldProps = {
  label: string;
  name: string;
  helperText?: string;
};

export const WizardFileField = ({
  label,
  name,
  helperText = '',
}: WizardFileFieldProps) => {
  const {
    formState: { errors },
    setValue,
  } = useFormContext();

  const errorMessage = (errors[name]?.message as string) || helperText;
  const isError = !!errors[name];

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setValue(name, file);
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {label}
      </Typography>
      <TextField
        fullWidth
        type="file"
        inputProps={{ accept: '.csv' }}
        onChange={handleFileChange}
        helperText={errorMessage}
        error={isError}
        sx={{
          '& .MuiInputBase-input': {
            padding: '8px 12px',
          },
        }}
      />
    </Box>
  );
};

